import React from 'react'
import { Switch, Route } from 'react-router-dom'
import OrderContainer from '../containers/orderContainer'
import ShowOrderContainer from '../containers/showOrderContainer'
import EditOrderContainer from '../containers/editOrderContainer'

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={OrderContainer} />
    <Route exact path={`${match.path}/all`} render={(props) => <OrderContainer {...props} presetScope="all" />} />
    <Route exact path={`${match.path}/fulfilled`} render={(props) => <OrderContainer {...props} presetScope="fulfilled" />} />
    <Route exact path={`${match.path}/unfulfilled`} render={(props) => <OrderContainer {...props} presetScope="unfulfilled" />} />
    <Route exact path={`${match.path}/paid`} render={(props) => <OrderContainer {...props} presetScope="paid" />} />
    <Route exact path={`${match.path}/unpaid`} render={(props) => <OrderContainer {...props} presetScope="unpaid" />} />
    <Route exact path={`${match.path}/new`} component={EditOrderContainer} />
    <Route path={`${match.path}/:id/edit`} component={EditOrderContainer} />
    <Route path={`${match.path}/:id`} component={ShowOrderContainer} />
  </Switch>
)
